import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function AdminServices() {
    const [items, setItems] = useState([]);
    const load = useCallback(() => api.get("/admin/services").then(r => setItems(r.data)), []);
    useEffect(() => { load(); }, [load]);

    const update = async (s, patch) => {
        const next = { ...s, ...patch };
        await api.put(`/admin/services/${s.id}`, next);
        toast.success("Guardado");
        load();
    };

    return (
        <div>
            <h1 className="font-display text-3xl font-bold text-stone-900 mb-6">Serviços</h1>
            <div className="bg-white rounded-xl border border-stone-200 divide-y divide-stone-100">
                {items.map(s => (
                    <div key={s.id} className="p-4 flex flex-col sm:flex-row sm:items-center gap-3">
                        <div className="flex-1">
                            <input defaultValue={s.title} onBlur={(e) => update(s, { title: e.target.value })} className="font-semibold text-stone-900 bg-transparent w-full" />
                            <input defaultValue={s.short_desc} onBlur={(e) => update(s, { short_desc: e.target.value })} className="text-sm text-stone-500 bg-transparent w-full" />
                        </div>
                        <label className="flex items-center gap-2 text-sm">
                            <input type="checkbox" defaultChecked={s.active} onChange={(e) => update(s, { active: e.target.checked })} className="accent-amber-600" />
                            Ativo
                        </label>
                        <input type="number" defaultValue={s.order} onBlur={(e) => update(s, { order: parseInt(e.target.value) || 0 })} className="w-16 border border-stone-200 rounded px-2 py-1 text-sm" />
                    </div>
                ))}
            </div>
        </div>
    );
}
